import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Navigation.css";
import logo from "../Assets/logo.svg";
import cartIcon from "../Assets/Interface/Shopping_Cart_02.svg";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { getCartCount } = useCart();

  const menuVariants = {
    closed: {
      x: "100%",
      transition: {
        type: "tween",
        duration: 0.3,
        ease: "easeInOut",
      },
    },
    open: {
      x: 0,
      transition: {
        type: "tween",
        duration: 0.3,
        ease: "easeInOut",
      },
    },
  };

  return (
    <div className="navigation">
      <div className="free-shipping">
        Free shipping for orders over NGN 100,000
      </div>
      <nav className="nav-content">
        <div className="nav-left">
          <div className="nav-logo">
            <Link to="/">
              <img src={logo} alt="Beautified By Linda" className="logo" />
            </Link>
          </div>
        </div>
        <div className="nav-center">
          <div className="nav-links">
            <Link to="/">Shop</Link>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/bookings">Book Now</Link>
          </div>
        </div>
        <div className="nav-right">
          <div className="nav-cart-container">
            <Link to="/cart" className="nav-link cart-link">
              <img src={cartIcon} alt="Cart" className="cart-icon" />
              {getCartCount() > 0 && (
                <span className="cart-count">{getCartCount()}</span>
              )}
            </Link>
          </div>
          <button className="account-button">
            <span>Account</span>
          </button>
          <button className="menu-button" onClick={() => setIsMenuOpen(true)}>
            <span className="menu-icon">☰</span>
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {isMenuOpen && (
          <>
            <motion.div
              className="menu-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsMenuOpen(false)}
            />
            <motion.div
              className="mobile-menu"
              variants={menuVariants}
              initial="closed"
              animate="open"
              exit="closed"
            >
              <div className="mobile-menu-header">
                <button
                  className="close-menu"
                  onClick={() => setIsMenuOpen(false)}
                >
                  ✕
                </button>
              </div>
              <div className="mobile-menu-links">
                <Link to="/" onClick={() => setIsMenuOpen(false)}>
                  Shop
                </Link>
                <Link to="/about" onClick={() => setIsMenuOpen(false)}>
                  About
                </Link>
                <Link to="/services" onClick={() => setIsMenuOpen(false)}>
                  Services
                </Link>
                <Link to="/bookings" onClick={() => setIsMenuOpen(false)}>
                  Book Now
                </Link>
                <Link to="/cart" onClick={() => setIsMenuOpen(false)}>
                  Cart
                </Link>
                <Link to="/account" onClick={() => setIsMenuOpen(false)}>
                  Account
                </Link>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Navigation;
